const DEFAULT_ITEM_PER_PAGE = 10

/**
 * Format the order of the item from pagination.
 * @param page - The page number.
 * @param itemIndex - The index of the item.
 * @param itemPerPage - The number of items per page.
 * @returns The formatted order.
 */
export function formatPaginationOrder(
  page: number,
  itemIndex: number,
  itemPerPage: number = DEFAULT_ITEM_PER_PAGE,
): number {
  const lastIndex = page * itemPerPage
  const firstIndex = lastIndex - itemPerPage
  const currentIndex = itemIndex
  const result = firstIndex + currentIndex + 1
  return result
}
